/*
 * Which VINs this browser session has already asked CARFAX about, unprompted.
 *
 * ⚠ WHY IT MUST EXIST. ViewInventory auto-requests a report for any record that has none, and it is
 * mounted from three places - /inventory/view/:id, the InventoryQuickView route, and directly from the
 * list grids via mixins/inventory/listViews.js getQuickViewComponent(). An operator arrowing through
 * grid rows would otherwise fire one BILLABLE CARFAX pull per row opened, and in a 60-record sample of
 * live inventory 21 had no rating. Without this the feature is a cost defect.
 *
 * ⚠ CLIENT-SIDE BECAUSE THERE IS NO ALTERNATIVE. The server does record every attempt -
 * CarfaxRatingProcessingStatusTracker, written at ~25 points in CarFaxService.cs - but no controller
 * exposes it and appraisalService has no call for it; the frontend only sees tracker state pushed over
 * the eventBus AFTER a request is already in flight. The one per-record signal readable at load is
 * carFaxRating itself, and null is ambiguous between never-tried, tried-and-failed, and needs-purchase.
 *
 * ⚠ KEYED BY VIN, NOT INVENTORY ID. The same vehicle appears on several records - 1075075, 1076075 and
 * 1078077 all carry WP0BB2A9XPS234155 - so keying by id would fire three requests for one car.
 *
 * ⚠ MODULE-LEVEL, which is what makes it "per session": it lives for the page load, so a reload or a
 * later visit tries again. Dean, 20 Sep. Durable idempotence would need the tracker exposed.
 */
const attempted = new Set()

const key = (vinNo) => String(vinNo === null || vinNo === undefined ? '' : vinNo).trim().toUpperCase()

export const hasAttemptedCarfaxAutoRequest = (vinNo) => {
  const vin = key(vinNo)
  return vin !== '' && attempted.has(vin)
}

/*
 * ⚠ Called BEFORE the response, not after. Failure, purchase-required and success must all stop the
 * retry - otherwise the third of inventory with no report re-requests on every open, which is the
 * exact cost this exists to prevent.
 */
export const markCarfaxAutoRequestAttempted = (vinNo) => {
  const vin = key(vinNo)
  if (vin === '') return
  attempted.add(vin)
}

//Tests only: module state outlives a single spec otherwise.
export const resetCarfaxAutoRequests = () => {
  attempted.clear()
}
